import { useScroll } from "@vueuse/core";
import { defineStore } from "pinia";
import { ref } from "vue";

const useSidebarLayoutStore = defineStore("sidebarLayout", () => {
  const mainRef = ref<HTMLElement | null>(null);
  function setMainRef(mainElement: HTMLElement) {
    mainRef.value = mainElement;
  }

  const { directions, isScrolling, y, arrivedState } = useScroll(mainRef, {
    throttle: 800,
    offset: {
      top: 800,
    },
  });

  const sidebarRef = ref<HTMLElement | null>(null);
  function setSidebarRef(sidebarElement: HTMLElement) {
    sidebarRef.value = sidebarElement;
  }

  const dynamicContentRef = ref<HTMLElement | null>(null);
  function setDynamicContentRef(dynamicContentElement: HTMLElement) {
    dynamicContentRef.value = dynamicContentElement;
  }

  return {
    mainRef,
    directions,
    y,
    arrivedState,
    isScrolling,
    setMainRef,
    sidebarRef,
    setSidebarRef,
    dynamicContentRef,
    setDynamicContentRef,
  };
});

export default useSidebarLayoutStore;
